import { render, staticRenderFns } from "./InterfaceBoolean.vue?vue&type=template&id=6c76cbbf"
import script from "./InterfaceBoolean.vue?vue&type=script&lang=js"
export * from "./InterfaceBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports